<template>
  <div class="withdraw-page">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-back" @click="back()">
        <van-icon name="arrow-left" />
      </div>
      <h1 class="header-title">{{ $t('withdraw.with_center') }}</h1>
      <div class="header-placeholder"></div>
    </header>

    <!-- 提現金額 -->
    <div class="amount-section">
      <div class="amount-label">{{ $t('withdraw.with_money') || '提現金額' }}</div>
      <div class="amount-input-row">
        <div class="amount-input-wrap">
          <span class="currency">HKD</span>
          <input v-model="withdraw_money" type="number" class="amount-input" />
        </div>
        <div class="all-btn" @click="allMoney()">{{ $t('index.all') || '全部' }}</div>
      </div>
    </div>

    <!-- 限額說明 -->
    <div class="info-row" @click="showLimitInfo = true">
      <van-icon name="info-o" class="info-icon" />
      <span class="info-text">{{ $t('withdraw.limit_desc') || '限額說明' }}</span>
    </div>

    <!-- 餘額顯示 -->
    <div class="balance-row">
      <span class="balance-label">{{ $t('my.balance') || '餘額' }}:</span>
      <span class="balance-value">{{ userInfo.money || '0.00' }} HKD</span>
    </div>

    <!-- 提現按鈕 -->
    <button class="withdraw-btn" @click="doWithdraw()">
      {{ $t('withdraw.immediately_withdraw') || '馬上提現' }}
    </button>

    <!-- 限額說明彈窗 -->
    <van-dialog v-model="showLimitInfo" :title="$t('withdraw.limit_desc') || '限額說明'" confirm-button-text="OK">
      <div class="limit-info-content">
        <p>1. {{ $t('withdraw.single_limit') || '單筆限額' }} {{ $t('withdraw.low') || '最低' }} {{ withdrawRole.min || 0 }} - {{ $t('withdraw.heigh') || '最高' }} {{ withdrawRole.max || 0 }}</p>
        <p>2. {{ $t('withdraw.with_num') || '提現次數' }} {{ withdrawRole.num || 0 }} {{ $t('withdraw.number') || '次' }}</p>
        <p>3. {{ $t('withdraw.with_tip') || '到賬時間說明' }}</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      withdraw_money: "",
      paypassword: "",
      showLimitInfo: false,
      userInfo: {},
      withdrawRole: {},
      bankInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserWithdrawRole() {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res => {
        if (res.code === 200) {
          this.withdrawRole = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          this.bankInfo = res.data.info || {};
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    allMoney() {
      this.withdraw_money = this.userInfo.money || '0';
    },
    doWithdraw() {
      if (this.withdraw_money === "" || this.withdraw_money <= 0) {
        this.$toast(this.$t("setting.correct_money") || '請填寫正確的金額');
        return false;
      }
      this.$http({
        method: 'post',
        data: {
          money: this.withdraw_money,
          // paypassword: this.paypassword
        },
        url: 'user_set_withdraw'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg);
          this.withdraw_money = "";
          this.getUserInfo();
          this.getUserWithdrawRole();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  },
  mounted() {
    this.getUserBankInfo();
  }
};
</script>

<style lang="less" scoped>
.withdraw-page {
  min-height: 100vh;
  background: #1a1a1a;
  color: #f5f5f5;
  padding: 0 20px;
}

/* 头部 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  position: relative;
}

.header-back {
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #fff;
  font-size: 32px;
  cursor: pointer;
}

.header-title {
  flex: 1;
  text-align: center;
  color: #00d200;
  font-size: 32px;
  margin: 0;
}

.header-placeholder {
  width: 40px;
}

/* 提現金額區域 */
.amount-section {
  margin-top: 30px;
}

.amount-label {
  font-size: 28px;
  color: #00d200;
  font-weight: 500;
  margin-bottom: 12px;
}

.amount-input-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.amount-input-wrap {
  flex: 1;
  height: 88px;
  border-bottom: 1px solid rgba(255,255,255,.2);
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 0 15px;
}

.currency {
  color: #fff;
  font-size: 28px;
  font-weight: 600;
  margin-right: 10px;
}

.amount-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 28px;
  height: 100%;

  &::placeholder {
    color: #888;
  }
}

.all-btn {
  color: #ff4444;
  font-size: 28px;
  font-weight: 600;
  cursor: pointer;
  padding: 10px 8px;
  white-space: nowrap;
}

/* 限額說明 */
.info-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 16px;
  cursor: pointer;
}

.info-icon {
  color: #888;
  font-size: 28px;
}

.info-text {
  color: #888;
  font-size: 28px;
}

/* 餘額顯示 */
.balance-row {
  margin-top: 20px;
  font-size: 28px;
}

.balance-label {
  color: #999;
}

.balance-value {
  color: #ff4444;
  font-weight: 600;
}

/* 提現按鈕 */
.withdraw-btn {
  width: 100%;
  height: 80px;
  background: #1dc74a;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 28px;
  font-weight: 400;
  cursor: pointer;
  margin-top: 30px;

  &:active {
    opacity: 0.9;
  }
}

/deep/ .van-dialog{
	width:65vw;
}
/deep/ .van-dialog__header {
  font-size: 32px;
  color:#333;
  margin:20px 0;
  padding-bottom: 20px;
  
}
/deep/ .van-dialog__footer {
	border-top: 1px solid #f0f0f0;
  font-size: 30px;
  color:#333;
}
/deep/ .van-dialog__footer button {
	
  font-size: 30px;
  color:#333;
  margin:20px 0;
}
/* 限額說明彈窗內容 */
.limit-info-content {
  padding: 16px 20px;
  font-size: 28px;
  color: #333;
  line-height: 1.8;

  p {
    margin: 0 0 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
